export const createAToZArray = () => {
  let alphabetArray: string[] = []
  for (let i = 97; i <= 122; i++) {
    alphabetArray.push(String.fromCharCode(i))
  }
  return alphabetArray
}
